import React, { useContext } from 'react';
import { LassieContext } from '../../context/LassieProvider';
import WplSwitch from '../wpl-switch/wplSwitch';
import WplMultipleButtonInput from '../wpl-multiple-button-input/wplMultipleButtonInput';
import settingsIcon from '../../assets/img/settings-icon.png';
import infoIcon from '../../assets/img/map-info.png';
import './map-settings.css';

export default function MapSettings({ popoutSettingsOpen, setPopoutSettingsOpen, setQaOpen, setPopoutReferencesOpen, popoutReferencesOpen, isHistoricLightningAnalysis = false }) {
    const { layerSettings, setLayerSettings } = useContext(LassieContext);
    const switchSettings = [
        { title: 'Lightning layer', key: 'lightning' },
        { title: 'Only show outside IEC', key: 'only_show_outside_iec', tooltip: 'Enable the Lightning layer to use this feature.' },
        // Not offered on the historic analysis: it shows every turbine at once, and every
        // strike has some turbine as its nearest, so the filter has nothing to remove there.
        ...(isHistoricLightningAnalysis
            ? []
            : [{ title: 'Strikes for nearest turbine', key: 'most_probable' }]),
        { title: 'Collection area', key: 'collection_area' },
    ];

    const handleClick = () => {
        setPopoutSettingsOpen(!popoutSettingsOpen);
        if (popoutReferencesOpen) { setPopoutReferencesOpen(false); }
    };

    return (
        <div className="popout-wrapper">
            <div className="settings-label-container">
                {popoutSettingsOpen && (
                    <div className="settings-container">
                        {/* The heatmap is only offered where the strikes are dense enough for
                            it to say anything - the historic analysis. Everything below it is
                            the same on every map. */}
                        {isHistoricLightningAnalysis && (
                            <WplSwitch
                                title="Heatmap"
                                value={layerSettings.heatmap}
                                onChanged={(v) =>
                                    setLayerSettings((prev) => ({ ...prev, heatmap: v }))
                                }
                                className="setting-input"
                            />
                        )}

                        {switchSettings.map(({ title, key, tooltip }) => (
                            <WplSwitch
                                key={key}
                                title={title}
                                value={layerSettings[key]}
                                onChanged={(v) => setLayerSettings((prev) => ({ ...prev, [key]: v }))}
                                className="setting-input"
                                tooltip={tooltip}
                            />
                        ))}

                        <WplMultipleButtonInput
                            title="Background"
                            options={['topographic', 'imagery', 'elevation']}
                            value={layerSettings.background}
                            onChanged={(v) => setLayerSettings((prev) => ({ ...prev, background: v }))}
                            className="setting-background"
                        />
                    </div>
                )}

                <div className="actions-container">
                    <div className="settings-icons-container" onClick={handleClick}>
                        <img src={settingsIcon} className="settings-icon" alt="settings icon" />
                        <div className={`arrow-icon ${popoutSettingsOpen ? 'open' : 'closed'}`}></div>
                    </div>
                    {popoutSettingsOpen && (
                        <img
                            src={infoIcon}
                            className="info-icon"
                            alt="Information icon"
                            onClick={() => setQaOpen({ status: true, type: 'settings' })}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}